import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Grid,
  FormControl,
  InputLabel,
  InputAdornment,
  OutlinedInput,
  Divider,
  Dialog,
  DialogTitle,
  Button,
  Snackbar,
  Alert,
  TextField,
  Avatar,
} from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import { appLogger, Http } from "../../utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { getDateTime } from "../../utils/data";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { IconWithToolTip } from "../common";
import DeleteDialog from "../../utils/common/DeleteDialog";
import {
  ROLE_USER_ADMIN,
  ROLE_USER_MANAGER,
  ROLE_USER_SUPERADMIN,
  UserInfo,
} from "../../model";
import {
  SORT_KEY_EMAIL,
  SORT_KEY_NAME,
  SORT_KEY_MODIFIED_ON,
  SORT_KEY_MODIFIED_BY,
} from "./constants";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ProductVersionDropdown from "../common/ProductVersionDropdown";
import { getDateTimeRange } from "../../utils/data";
import NoProductMessage from "../../utils/common/NoProductMessage";

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
}

function TablePaginationActions(props: TablePaginationActionsProps) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </Box>
  );
}

const Manage = (props: any) => {
  const {
    ProVersion,
    setProVersion,
    filterDate,
    setFilterDate,
    contextProVersion,
    setcontextProVersion,
    contextRedirectProdPage,
    setContextCorrelationReportStartDate,
    setContextCorrelationReportEndDate,
    ContextCorrelationReportStartDate,
    ContextCorrelationReportEndDate,
  } = useContext(UserContext) as UserLoginInfo;
  const navigate = useNavigate();
  const [initialData, setInitialData] = React.useState([] as UserInfo[]);
  const [users, setUsers] = React.useState([] as UserInfo[]);
  const [searchUsers, setSearchUsers] = React.useState([] as any);
  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  const [orderBy, setOrderBy] = useState(SORT_KEY_MODIFIED_ON);
  const [order, setOrder] = useState<"asc" | "desc">("desc");
  const [itemLimit, setItemLimit] = useState({
    lowerLimit: 0,
    upperLimit: 9,
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [search, setSearch] = React.useState("");
  const [searchKeyword, setSearchKeyword] = React.useState("");
  const [isLoading, setIsloading] = React.useState(false);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [deleteTxt, setDeleteTxt] = useState("");
  const [deleteEnable, setDeleteEnable] = useState(false);
  const [deleteID, setDeleteID] = useState([] as any);
  const [openResetPwDialog, setOpenResetPwDialog] = useState(false);
  const [focusEmailId, setFocusEmailId] = useState("");
  const [alertOpenResetPw, setAlertOpenResetPw] = React.useState(false);
  const [errorAlertOpenResetPw, setErrorAlertOpenResetPw] =
    React.useState(false);
  const [editID, setEditID] = useState({} as UserInfo);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [productResponse, setProductResponse] = React.useState([] as any);

  appLogger.info({
    infoObj: {
      method: "DashboardContent",
      component: "dashboard",
      fileName: "index.tsx",
      location: location,
    },
  });
  const currDate = new Date();
  const stDate = new Date();
  let stDateTimestamp: any = "";
  let currDateTimestamp: any = "";
  // const currDateVal = currDate.setHours(23, 59, 59, 999);
  stDate.setDate(currDate.getDate() - 7);
  if (stDate && currDate) {
    stDateTimestamp = stDate.getTime();
    currDateTimestamp = currDate.getTime();
  }

  const [product, setProduct] = React.useState("");
  const [selectedProduct, setSelectedProduct] = React.useState<any>();
  const [version, setVersion] = React.useState("");
  // const [userData, setUserData] = React.useState([] as any);
  const [startDateValue, setStartDateValue] = React.useState(
    ContextCorrelationReportStartDate
  );
  const [endDateValue, setEndDateValue] = React.useState(
    ContextCorrelationReportEndDate
  );
  const [selectedProVerData, setselectedProVerData] = React.useState([] as any);
  const [proVerUrl, setproVerUrl] = React.useState("");
  const [reportsTicketsData, setReportsTicketsData] = React.useState([] as any);
  const [selectedProVerDataType, setselectedProVerDataType] =
    React.useState("confirm");

  // setContextCorrelationReportEndDate,
  const getUTCDate = (dateValue: any) => {
    const utcDate = new Date(parseInt(dateValue, 10));
    return utcDate;
  };

  const changeEndDateValue = (dateValue: any) => {
    let utcDate = null;
    if (dateValue < 0) {
      dateValue = dateValue * -1;
    }

    if (dateValue != null) {
      utcDate = dateValue != null && Date.parse(dateValue.toString());
    }

    const date = new Date(dateValue.target.value);

    const timestamp = date.getTime();
    appLogger.info({
      infoObj: {
        method: "changeEndDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });

    setEndDateValue(timestamp);
    setContextCorrelationReportEndDate(timestamp);
  };
  useEffect(() => {
    setContextCorrelationReportStartDate(startDateValue);
    setContextCorrelationReportEndDate(endDateValue);
  }, [startDateValue, endDateValue]);

  useEffect(() => {
    if (selectedProVerDataType == "confirm" && selectedProVerData.length > 0) {
      fetchReportTicketsData();
      setIsloading(true);
    }
  }, [product, version, selectedProVerDataType]);
  useEffect(() => {
    if (product && version && proVerUrl) {
      fetchReportTicketsData();
      setIsloading(true);
    }
  }, [startDateValue]);

  // useEffect(() => {
  //   if (product && version && proVerUrl) {
  //     if (
  //       (startDateValue && endDateValue) ||
  //       (startDateValue === null && endDateValue === null)
  //     ) {
  //       fetchReportTicketsData();
  //       setIsloading(true);
  //     }
  //   }
  // }, [startDateValue, endDateValue]);

  useEffect(() => {
    setFilterDate({
      startDate: startDateValue,
      endDate: endDateValue,
    });
  }, [endDateValue]);

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "dashboard",
        fileName: "index.tsx",
        filterDate: filterDate,
      },
    });
  }, [filterDate]);

  const changeStartDateValue = (dateValue: any) => {
    let utcDate = null;
    if (dateValue < 0) {
      dateValue = dateValue * -1;
    }

    if (dateValue != null) {
      utcDate = dateValue != null && Date.parse(dateValue.toString());
    }

    const date = new Date(dateValue.target.value);

    const timestamp = date.getTime();
    setStartDateValue(timestamp);
    setContextCorrelationReportStartDate(timestamp);
    appLogger.info({
      infoObj: {
        method: "changeStartDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
    if (timestamp > endDateValue) {
      setEndDateValue(null);
      setContextCorrelationReportEndDate(null);
    }
  };

  useEffect(() => {
    if (
      userInfo &&
      userInfo.idToken &&
      userInfo.idToken.length > 0 &&
      productResponse.length < 1
    ) {
      Http.get({
        url: `/api/v2/products/0`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.productNameList &&
            response.productNameList.length > 0
          ) {
            response &&
              response.productNameList &&
              response.productNameList.length > 0 &&
              response.productNameList.sort((a: any, b: any) =>
                a.name.localeCompare(b.name)
              );
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                productResponse: response,
              },
            });
            setProductResponse(response.productNameList);
            setProduct(ProVersion.product || response.productNameList[0].id);
            setVersion(
              ProVersion.version || response.productNameList[0].version
            );
            setSelectedProduct(response.productNameList[0]);

            setProVersion({
              product: ProVersion.product || response.productNameList[0].id,
              version:
                ProVersion.version || response.productNameList[0].version,
            });
            let tempurl = "";
            if (Array.isArray(contextProVersion)) {
              setcontextProVersion(contextProVersion);
              setselectedProVerData(contextProVersion);
              contextProVersion &&
                contextProVersion.length > 0 &&
                contextProVersion.map((data: any) => {
                  tempurl += `&prodId=${data.value}&prodVersion=${data.version}`;
                });
              setproVerUrl(tempurl);
            } else {
              setselectedProVerData([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                },
              ]);
              setcontextProVersion([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                  proversion:
                    response.productNameList[0].name +
                    response.productNameList[0].version,
                },
              ]);
              tempurl = `&prodId=${response.productNameList[0].id}&prodVersion=${response.productNameList[0].version}`;
              setproVerUrl(tempurl);
            }
            setIsloading(false);
          } else {
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                userInfo: userInfo,
              },
            });
            setIsloading(false);
            if (
              !contextRedirectProdPage &&
              (userInfo?.userDetails?.userRole == ROLE_USER_SUPERADMIN ||
                userInfo?.userDetails?.userRole == ROLE_USER_MANAGER ||
                userInfo?.userDetails?.userRole == ROLE_USER_ADMIN)
            ) {
              navigate("/products");
            }
            // props.snackbarShowMessage("No products created in your organization. Create a product first", "error");
            // setTimeout(() => {
            //   navigate("/add-product")
            // }, 2000);
          }
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
          setIsloading(false);
        });
    }
  }, [userInfo]);

  const fetchReportTicketsData = () => {
    if (proVerUrl) {
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }`;
      //&endDate=${endDateValue ? endDateValue : ""}
      Http.get({
        url: `/api/v2/correlation/counts?${proVerUrl}${datewiseFilter}&type=BUG_REPORT`,
        state: userInfo,
      })
        .then((response: any) => {
          setReportsTicketsData(response.topics);
          appLogger.info({
            infoObj: {
              method: "fetchReportTicketsData",
              component: "cuvo-metrics-dashboard",
              fileName: "index.tsx",
              InsightsData: response.feedbackMetrics,
            },
          });
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
          //props.snackbarShowMessage(error.message, "error");
          appLogger.error({
            errObj: {
              method: "fetchReportTicketsData",
              component: "cuvo-metrics-dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
        });
    } else {
      setIsloading(false);
    }
  };

  const selectedProVerDataFn = (selectedProVerData: any, type: any) => {
    let getData = selectedProVerData;
    getData = selectedProVerData;
    setselectedProVerData(selectedProVerData);

    HandleContextSelectedProVer(getData);
    setselectedProVerData(getData);
    let tempproVerUrl = "";
    getData &&
      getData.length > 0 &&
      getData.map((data: any) => {
        tempproVerUrl += `&prodId=${data.value}&prodVersion=${data.version}`;
      });
    setproVerUrl(tempproVerUrl);
    setselectedProVerDataType(selectedProVerData.type);
  };
  const HandleContextSelectedProVer = (data: any) => {
    setcontextProVersion(data);
  };

  const clearDate = () => {
    setStartDateValue(null);
    setEndDateValue(null);
    // getDateTimeRange(null);

    setFilterDate({
      startDate: "",
      endDate: "",
    });
  };

  const renderNoProductMessage = () => {
    let res = <></>;
    if (productResponse.length == 0 && !isLoading) {
      res = <NoProductMessage />;
    }
    return res;
  };

  const renderColor = (val: number) => {
    let colour = "";
    if (val >= 0 && val < 1) {
      colour = "#e51919";
    } else if (val >= 1 && val < 2) {
      colour = "#f97b28";
    } else if (val >= 2 && val < 3) {
      colour = "#f4c51a";
    } else if (val >= 3 && val < 4) {
      colour = "#76d43b";
    } else if (val >= 4 && val <= 5) {
      colour = "#028128";
    }
    return colour;
  };

  const minDateTime = new Date();
  minDateTime.setHours(17);
  const maxDateTime = new Date();
  maxDateTime.setHours(20);

  const hadleEditPopup = () => {
    setEditOpen(false);
  };

  const setDeleteHandle = (e: any) => {
    setDeleteTxt(e.target.value);
    setDeleteEnable(false);

    if (e.target.value.toLowerCase() == "delete") {
      setDeleteEnable(true);
    }
  };

  const clearInput = () => {
    setDeleteTxt("");
    setDeleteEnable(false);
  };

  const handleDeleteOpen = (user: any) => {
    setDeleteTxt("");
    appLogger.info({
      infoObj: {
        method: "handleDeleteOpen",
        component: "users",
        fileName: "manage.tsx",
        deleteUser: user,
      },
    });
    setDeleteID(user);
    setDeleteOpen(true);
  };

  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  const hadleEditOpen = (user: UserInfo) => {
    appLogger.info({
      infoObj: {
        method: "hadleEditOpen",
        component: "users",
        fileName: "manage.tsx",
        editUser: user,
      },
    });
    setEditID(user);
    setEditOpen(true);
  };

  useEffect(() => {}, [deleteID]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    if (event.target.value === "-1") {
      setItemLimit({
        lowerLimit: 0,
        upperLimit: users.length - 1,
      });
    } else {
      setItemLimit({
        lowerLimit: 0,
        upperLimit: parseInt(event.target.value, 10) - 1,
      });
    }
  };

  const handleRequestSort = (property: string) => {
    if (orderBy === property) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setOrder("asc");
      setOrderBy(property);
    }
  };

  useEffect(() => {
    setUsers(users);
  }, [alertOpen, errorAlertOpen]);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleErrorAlertClose = () => {
    setErrorAlertOpen(false);
  };

  const deleteUser = () => {
    setIsloading(true);
    Http.deleteReq({
      url: `/api/v2/users/${deleteID.id}`,
      state: userInfo,
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "deleteUser",
            component: "users",
            fileName: "manage.tsx",
            deleteUserResponse: response,
          },
        });
        setDeleteOpen(false);
        setIsloading(false);
        setAlertOpen(true);
        setUsers(users.filter((e: any) => e.id != deleteID.id));
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "deleteUser",
            component: "users",
            fileName: "manage.tsx",
            err: error,
          },
        });
        setIsloading(false);
        setErrorAlertOpen(true);
      });
  };

  function compareEmailId(a: UserInfo, b: UserInfo) {
    return a.emailId.localeCompare(b.emailId);
  }

  function compareEmailIdDesc(a: any, b: any) {
    return b.emailId.localeCompare(a.emailId);
  }

  function compareFirstName(a: UserInfo, b: UserInfo) {
    return a.nameFirst.localeCompare(b.nameFirst);
  }

  function compareFirstNameDesc(a: UserInfo, b: UserInfo) {
    return b.nameFirst.localeCompare(a.nameFirst);
  }

  function compareModifiedBy(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedBy && !a.lastModifiedBy) {
      return 0;
    }
    if (!b.lastModifiedBy) {
      return 1;
    }
    if (!a.lastModifiedBy) {
      return -1;
    }
    return a.lastModifiedBy.localeCompare(b.lastModifiedBy);
  }

  function compareModifiedByDesc(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedBy && !a.lastModifiedBy) {
      return 0;
    }
    if (!b.lastModifiedBy) {
      return -1;
    }
    if (!a.lastModifiedBy) {
      return 1;
    }
    return b.lastModifiedBy.localeCompare(a.lastModifiedBy);
  }

  function compareModifiedOn(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedOn && !a.lastModifiedOn) {
      return 0;
    }
    if (!b.lastModifiedOn) {
      return 1;
    }
    if (!a.lastModifiedOn) {
      return -1;
    }
    return b.lastModifiedOn > a.lastModifiedOn ? -1 : 1;
  }

  function compareModifiedOnDesc(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedOn && !a.lastModifiedOn) {
      return 0;
    }
    if (!b.lastModifiedOn) {
      return -1;
    }
    if (!a.lastModifiedOn) {
      return 1;
    }
    return b.lastModifiedOn > a.lastModifiedOn ? 1 : -1;
  }

  const sortFunction = (list: UserInfo[]) => {
    if (list.length > 0) {
      const tempSortedUsers = [...list];
      let sortedList: UserInfo[] = [];
      if (order === "asc") {
        if (orderBy === SORT_KEY_EMAIL) {
          sortedList = tempSortedUsers.sort(compareEmailId);
        } else if (orderBy === SORT_KEY_NAME) {
          sortedList = tempSortedUsers.sort(compareFirstName);
        } else if (orderBy === SORT_KEY_MODIFIED_ON) {
          sortedList = tempSortedUsers.sort(compareModifiedOn);
        } else if (orderBy === SORT_KEY_MODIFIED_BY) {
          sortedList = tempSortedUsers.sort(compareModifiedBy);
        }
      }
      if (order === "desc") {
        if (orderBy === SORT_KEY_EMAIL) {
          sortedList = tempSortedUsers.sort(compareEmailIdDesc);
        } else if (orderBy === SORT_KEY_NAME) {
          sortedList = tempSortedUsers.sort(compareFirstNameDesc);
        } else if (orderBy === SORT_KEY_MODIFIED_ON) {
          sortedList = tempSortedUsers.sort(compareModifiedOnDesc);
        } else if (orderBy === SORT_KEY_MODIFIED_BY) {
          sortedList = tempSortedUsers.sort(compareModifiedByDesc);
        }
      }
      setUsers(sortedList);
      return sortedList;
    }
  };

  useEffect(() => {
    sortFunction(users);
  }, [order, orderBy]);

  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      setSearchKeyword(search);
      e.preventDefault();
    }
  };

  const handleSearchTyping = (e: any) => {
    setSearch(e.target.value);
    if (e.target.value !== "") {
      const temp = searchUsers;
      const filteredRows = temp.filter((row: UserInfo) => {
        return row.nameFirst
          .toLowerCase()
          .includes(e.target.value.toLowerCase());
      });
      setUsers(filteredRows);
    } else {
      setUsers(searchUsers);
    }
  };

  const searchClear = () => {
    setSearch("");
    setUsers(searchUsers);
  };

  const handleResetPassword = (email: string) => {
    setOpenResetPwDialog(true);
    setFocusEmailId(email);
  };

  const handleCloseResetPwDialog = () => {
    setOpenResetPwDialog(false);
  };

  const resetPassword = () => {
    setIsloading(true);
    const body = {
      emailId: focusEmailId,
    };
    Http.post({
      url: `/api/v2/users/reset-password`,
      state: userInfo,
      body,
    })
      .then((response: any) => {
        setAlertOpenResetPw(true);
        setOpenResetPwDialog(false);
        setIsloading(false);
        setFocusEmailId("");
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "resetPassword",
            component: "users",
            fileName: "manage.tsx",
            err: error,
          },
        });
        setIsloading(false);
        setErrorAlertOpenResetPw(true);
      });
  };

  const handleAlertCloseResetPw = () => {
    setAlertOpenResetPw(false);
  };

  const handleErrorAlertCloseResetPw = () => {
    setErrorAlertOpenResetPw(false);
  };

  const handleClosePopup = () => {
    props.setClosePopup();
    setEditOpen(false);
  };
  // useEffect(() => {
  //   if (
  //     userInfo &&
  //     userInfo.idToken &&
  //     userInfo.idToken.length > 0 &&
  //     productLists.length < 1
  //   ) {
  //     Http.get({
  //       url: `/api/v2/products/0`,
  //       state: userInfo,
  //     })
  //       .then((response: any) => {
  //         if (
  //           response &&
  //           response.productNameList &&
  //           response.productNameList.length > 0
  //         ) {
  //           const prods = response.productNameList;
  //           setProductResponse(response.productNameList);
  //         } else {
  //           setIsloading(false);
  //           props.snackbarShowMessage("No Product Found", "error");
  //         }
  //       })
  //       .catch((error: any) => {
  //         props.snackbarShowMessage(error.message, "error");
  //         setIsloading(false);
  //       });
  //   }
  // }, [userInfo]);
  const handleRedirectTickets = (topic: any) => {
    const stateObj = {
      pageType: "listTopicPage",
      topic: topic,
    };
    navigate(`/view-tickets/${topic}`, { state: stateObj });

    // navigate("/view-tickets", { state: stateObj });
  };
  const topicsList = [
    {
      name: "Cam issue",
      open: "55",
      closed: "45",
      replied: "78",
      noOfusers: "895",
    },
    {
      name: "The picture is not displaying properly",
      open: "55",
      closed: "45",
      replied: "78",
      noOfusers: "895",
    },
    {
      name: "Disturbing grainy images ",
      open: "55",
      closed: "45",
      replied: "78",
      noOfusers: "895",
    },
    {
      name: "Unable to see images properly",
      open: "55",
      closed: "45",
      replied: "78",
      noOfusers: "895",
    },
    {
      name: "Image quality is too poor",
      open: "55",
      closed: "45",
      replied: "78",
      noOfusers: "895",
    },
  ];
  const renderStatusCount = (data: any, type: any) => {
    let count = 0;

    if (data && data.statusCounts && data.statusCounts.length > 0) {
      const resp = data.statusCounts.filter((e: any) => e.status == type);
      if (resp && resp.length > 0) {
        count = resp[0].ticketCount;
      }

      // data.statusCounts.map((type: any) => {
      //   if (type.status == "open") {
      //     count = type.ticketCount;
      //   }
      // });
      return count;
    }
  };

  return (
    <Box sx={{ p: 1 }}>
      <Grid className="feedback-bug-filter" container sx={{ mb: 2 }}>
        <Grid
          xs={12}
          sm={12}
          md={12}
          lg={4}
          xl={4}
          className="pro-ver-dropdown-grid"
        >
          <ProductVersionDropdown
            productResponse={productResponse}
            selectedProVerData={selectedProVerData}
            selectedProVerDataFn={selectedProVerDataFn}
            contextProVersion={contextProVersion}
            type="cuvo-topics"
          />
        </Grid>
        <Grid item xs={6} sm={4} md={3} lg={2.3} sx={{ ml: "auto" }}>
          <Box>
            <TextField
              className="date-picker custom-select"
              id="datetime-local-start"
              label="Start Date"
              type="datetime-local"
              value={startDateValue ? getDateTimeRange(startDateValue) : ""}
              onChange={(newValue: any) => {
                changeStartDateValue(newValue);
              }}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                max: maxDateTime.toISOString().slice(0, 16),
              }}
            />
          </Box>
        </Grid>
        {/* <Grid item xs={6} sm={4} md={3} lg={2.3}>
          <Box>
            <TextField
              className="date-picker custom-select"
              id="datetime-local-end"
              label="End Date"
              value={endDateValue ? getDateTimeRange(endDateValue) : ""}
              onChange={(newValue: any) => {
                changeEndDateValue(newValue);
              }}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                min: getDateTimeRange(startDateValue),
                max: maxDateTime.toISOString().slice(0, 16),
              }}
              type="datetime-local"
            />
          </Box>
        </Grid> */}
        {startDateValue || endDateValue ? (
          <Grid item className="clear-option" title="Clear">
            <CloseIcon onClick={clearDate} />
          </Grid>
        ) : (
          ""
        )}
      </Grid>
      <Grid className="manage-search" container spacing={2}>
        <Grid item xs={12} md={4} lg={2} sx={{ mb: 1 }}>
          <FormControl className="custom-select" fullWidth>
            <InputLabel>Search</InputLabel>
            <OutlinedInput
              type="text"
              value={search}
              onChange={handleSearchTyping}
              onKeyPress={handleKeyPress}
              id="search-input"
              endAdornment={
                <>
                  {search && (
                    <InputAdornment position="end" onClick={searchClear}>
                      <IconButton
                        aria-label="search icon"
                        edge="end"
                        className="search-fb-icon"
                      >
                        <CloseIcon className="cursor-pointer" />
                      </IconButton>
                    </InputAdornment>
                  )}
                  <InputAdornment position="end">
                    <IconButton aria-label="search icon" edge="end">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                </>
              }
              label="Search"
            />
          </FormControl>
        </Grid>
      </Grid>
      <Box className="table-wrap">
        <Table className={isLoading ? "table loader" : "table"}>
          <TableHead>
            <TableRow sx={{ background: "#DBDCE0" }}>
              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_NAME}
                  direction={orderBy === SORT_KEY_NAME ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_NAME);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Topic Name</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_NAME
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_EMAIL}
                  direction={orderBy === SORT_KEY_EMAIL ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_EMAIL);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Open</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_EMAIL
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_EMAIL}
                  direction={orderBy === SORT_KEY_EMAIL ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_EMAIL);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Pending Response</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_EMAIL
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_EMAIL}
                  direction={orderBy === SORT_KEY_EMAIL ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_EMAIL);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Replied</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_EMAIL
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_EMAIL}
                  direction={orderBy === SORT_KEY_EMAIL ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_EMAIL);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Closed</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_EMAIL
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_EMAIL}
                  direction={orderBy === SORT_KEY_EMAIL ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_EMAIL);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Number of users</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_EMAIL
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>
              {/* <TableCell>
                  <TableSortLabel
                    active={orderBy === SORT_KEY_MODIFIED_BY}
                    direction={orderBy === SORT_KEY_MODIFIED_BY ? order : "asc"}
                    onClick={() => {
                      handleRequestSort(SORT_KEY_MODIFIED_BY);
                    }}
                    hideSortIcon={false}
                    IconComponent={SwapVertIcon}
                  >
                    <Typography style={{fontWeight: '700', color: '#000'}}>Modified By</Typography>
                  </TableSortLabel>
                </TableCell> */}

              <TableCell>
                <Typography>Actions</Typography>
              </TableCell>
            </TableRow>
          </TableHead>

          {/* <TableBody>
            {(rowsPerPage > 0
              ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : rows
            ).map((row) => (
              <TableRow key={row.name}>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.version}</TableCell>
                <TableCell>{row.platform}</TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody> */}

          <TableBody>
            {(rowsPerPage > 0
              ? reportsTicketsData.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : reportsTicketsData
            ).map((topic: any, index: number) => {
              if (index < itemLimit.lowerLimit) {
                return;
              }
              if (index > itemLimit.upperLimit) {
                return;
              }
              return (
                <TableRow key={index}>
                  <TableCell>
                    {/* {topic.profilePic && (
                      <img className="prod-logo" src={user.profilePic} />
                    )} */}

                    {/* {!user.profilePic && (
                      <Typography className="prod-logo-txt">
                        {user.nameFirst[0].toUpperCase()}
                      </Typography>
                    )} */}
                    <Typography
                    //   onClick={() => hadleEditOpen(user)}
                    >
                      {topic.topic}
                    </Typography>
                    <Typography></Typography>
                  </TableCell>

                  <TableCell>
                    <Typography> {renderStatusCount(topic, "open")}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {" "}
                      {renderStatusCount(topic, "pending response")}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {" "}
                      {renderStatusCount(topic, "replied")}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {" "}
                      {renderStatusCount(topic, "closed")}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {" "}
                      <Avatar
                        sx={{
                          fontSize: "12px",
                          background: "#2858D3",
                          display: "inline-flex",
                          border: "1px solid #FFF",
                        }}
                      >
                        {topic.totalUserCount}
                      </Avatar>
                    </Typography>
                  </TableCell>
                  {/* <TableCell>
                      <Typography>
                        {user && user.lastModifiedBy ? user.lastModifiedBy : ""}
                      </Typography>
                    </TableCell> */}

                  <TableCell>
                    <Button
                      variant="text"
                      sx={{
                        fontSize: 12,
                        color: "#2858D3",
                        fontWeight: 700,
                        marginLeft: 0,
                        padding: 0,
                      }}
                      // onClick={handleRedirectTickets}
                      onClick={() => handleRedirectTickets(topic.topic)}
                    >
                      View Tickets
                    </Button>
                    {/* <Typography
                      style={{ color: "#0157FF", cursor: "pointer" }}
                      onClick={() => handleRedirectTickets(topic.topic)}
                    >
                      View Tickets{" "}
                    </Typography> */}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          <TableFooter>
            <TableRow></TableRow>
          </TableFooter>
        </Table>
        <TablePagination
          component="div"
          rowsPerPageOptions={[10, 15, 20]}
          count={reportsTicketsData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </Box>

      {deleteOpen && (
        <DeleteDialog
          deletepopupShow={deleteOpen}
          deletepopupClose={handleDeleteClose}
          handleDeleteConfirm={deleteUser}
          type="user"
        />
      )}

      <Dialog
        className="form-container text-center"
        onClose={handleCloseResetPwDialog}
        open={openResetPwDialog}
      >
        <Box
          className={isLoading ? "form-wrap loader" : "form-wrap"}
          style={{ paddingLeft: "24px", paddingRight: "24px" }}
        >
          <DialogTitle>Reset Password</DialogTitle>
          <Typography className="info">
            Do you really want to reset password for {focusEmailId}?
          </Typography>
          <Box style={{ paddingBottom: "16px", paddingTop: "16px" }}>
            <Button variant="contained" onClick={resetPassword}>
              reset
            </Button>
            <Button
              variant="text"
              onClick={handleCloseResetPwDialog}
              style={{ marginLeft: "10px" }}
            >
              cancel
            </Button>
          </Box>
        </Box>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertOpen}
        autoHideDuration={2000}
        onClose={handleAlertClose}
      >
        <Alert onClose={handleAlertClose} severity="success">
          user deleted successfully !!!
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={errorAlertOpen}
        autoHideDuration={2000}
        onClose={handleErrorAlertClose}
      >
        <Alert onClose={handleErrorAlertClose} severity="error">
          Error in user delete !!!
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertOpenResetPw}
        autoHideDuration={2000}
        onClose={handleAlertCloseResetPw}
      >
        <Alert onClose={handleAlertCloseResetPw} severity="success">
          Password reset successfully !!!
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={errorAlertOpenResetPw}
        autoHideDuration={2000}
        onClose={handleErrorAlertCloseResetPw}
      >
        <Alert onClose={handleErrorAlertCloseResetPw} severity="error">
          Error in password reset !!!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Manage;
